module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.6f916ce8.ttf";